import env from '@beam-australia/react-env';
import { getAttr } from '../../../../../../features/helpers/apiHelpers';

const getCitizenOrCompanyName = (
  commentOwner,
  company,
  companyLabel,
  citizenLabel,
  missingInformationText,
) => {
  if (company !== undefined) {
    const name = getAttr(company, 'name') ?? missingInformationText;
    return `${companyLabel}: ${name}`;
  }

  const name = getAttr(commentOwner, 'name') ?? missingInformationText;
  return `${citizenLabel}: ${name}`;
};

const joinAddressInformation = (city, postalCode, streetName) =>
  [streetName, postalCode, city].filter((info) => !!info).join(', ');

const getCitizenOrCompanyAddress = (
  isCompany,
  commentOwner,
  company,
  companyLabel,
  citizenLabel,
  missingInformationText,
) => {
  if (isCompany) {
    const postalCode = getAttr(company, 'postalCode');
    const city = getAttr(company, 'city');
    const streetName = getAttr(company, 'streetName');
    const companyName = getAttr(company, 'name');

    const addressText =
      joinAddressInformation(city, postalCode, streetName) ||
      missingInformationText;

    return `${companyLabel}: ${companyName} - ${addressText}`;
  }

  const postalCode = getAttr(commentOwner, 'postalCode');
  const city = getAttr(commentOwner, 'city');
  const streetName = getAttr(commentOwner, 'streetName');

  const addressText =
    joinAddressInformation(city, postalCode, streetName) ||
    missingInformationText;

  return `${citizenLabel}: ${addressText}`;
};

export const getResponderInfo = (
  isEmployee,
  isCompany,
  commentOwner,
  company,
  companyLabel,
  employeeLabel,
  citizenLabel,
  missingInformationText,
) => {
  const showEmployeeInformation =
    env('EXT_SHOW_EMPLOYEE_INFORMATION') === 'true';
  if (isEmployee) {
    return showEmployeeInformation
      ? getAttr(commentOwner, 'employeeDisplayName') ?? employeeLabel
      : employeeLabel;
  }

  const useNameOnResponder = env('EXT_SHOW_RESPONDER_NAME') === 'true';

  if (useNameOnResponder) {
    return getCitizenOrCompanyName(
      commentOwner,
      company,
      companyLabel,
      citizenLabel,
      missingInformationText,
    );
  }

  return getCitizenOrCompanyAddress(
    isCompany,
    commentOwner,
    company,
    companyLabel,
    citizenLabel,
    missingInformationText,
  );
};
